import * as React from 'react'

export const checkOverflow = (
  breadcrumbRef: React.RefObject<HTMLDivElement>,
  windowWidth: number
) => {
  const [isOverflowing, setIsOverflowing] = React.useState(false)

  React.useEffect(() => {
    const checkIfOverflowing = () => {
      if (breadcrumbRef.current) {
        const element = breadcrumbRef.current as HTMLElement
        const needsToScroll = element.scrollWidth > element.offsetWidth
        const isWiderThanScreen =
          element.scrollWidth > (windowWidth || 0) ||
          element.scrollWidth > document.documentElement.clientWidth
        setIsOverflowing(needsToScroll || isWiderThanScreen)
      }
    }

    checkIfOverflowing()

    window.addEventListener('resize', () => {
      checkIfOverflowing()
    })

    return () =>
      window.removeEventListener('resize', () => {
        checkIfOverflowing()
      })
  }, [breadcrumbRef.current])

  return isOverflowing
}
